<template>
    <UContainer class="bg-white p-8 mt-8 rounded leading-8">
        <UiComponentTypography class-name="mt-6" tag="h1">
            قوانین و مقررات فروشگاه اینترنتی نرس‌لند
        </UiComponentTypography>
        <UiComponentTypography class-name="mt-6" tag="h2" variant="h3">1. تعاریف و اصطلاحات </UiComponentTypography>
        <UiComponentTypography class-name="mt-4">
            <b>نرس‌لند:</b> به معنای فروشگاه اینترنتی نرس‌لند که در زمینه فروش انواع قهوه فعالیت می‌کند.
        </UiComponentTypography>
        <UiComponentTypography class-name="mt-4">
            <b>مشتری:</b> هر فردی که از طریق وب‌سایت نرس‌لند اقدام به خرید محصول می‌کند.
        </UiComponentTypography>
        <UiComponentTypography class-name="mt-4">
            <b>محصول:</b> به معنای تمامی اقلام قابل عرضه در وب‌سایت نرس‌لند، از جمله انواع قهوه و لوازم مرتبط.
        </UiComponentTypography>
        <UiComponentTypography class-name="mt-6" tag="h2" variant="h3"> 2. روش‌های ارسال </UiComponentTypography>
        <UiComponentTypography class-name="mt-4">
            محصولات از طریق پست، باربری، تیپاکس، پیک و تحویل در محل به دست مشتریان می‌رسند. زمان تحویل سفارشات بین 1 تا
            5 روز کاری خواهد بود. برخی از خریدها شامل ارسال رایگان خواهند بود که در هنگام نهایی‌کردن خرید در سبد خرید
            مشخص می‌شود.
        </UiComponentTypography>
        <UiComponentTypography class-name="mt-6" tag="h2" variant="h3">3. روش‌های پرداخت</UiComponentTypography>
        <UiComponentTypography class-name="mt-4">
            مشتریان می‌توانند از طریق پرداخت آنلاین، کارت به کارت، پرداخت در محل و یا به صورت اقساطی خرید خود را انجام
            دهند. امکان پرداخت اقساطی برای برخی از خریدها با هماهنگی قبلی فراهم است.
        </UiComponentTypography>
        <UiComponentTypography class-name="mt-6" tag="h2" variant="h3">4. بازگشت و تعویض کالا</UiComponentTypography>
        <UiComponentTypography class-name="mt-4">
            مشتریان تا 7 روز پس از تحویل کالا می‌توانند درخواست بازگشت یا تعویض محصول را بدهند، مشروط به اینکه پلمپ
            محصول باز نشده باشد. هزینه ارسال برای بازگشت کالا بر عهده مشتری است.
        </UiComponentTypography>
        <UiComponentTypography class-name="mt-6" tag="h2" variant="h3">5. پشتیبانی مشتریان</UiComponentTypography>
        <UiComponentTypography class-name="mt-4">
            نرس‌لند پشتیبانی آنلاین، شبکه‌های اجتماعی و تلفنی را ارائه می‌دهد. ساعات کاری پشتیبانی از 9 صبح تا 3 بعد از
            ظهر است.
        </UiComponentTypography>
        <UiComponentTypography class-name="mt-6" tag="h2" variant="h3">6. مسئولیت‌ها</UiComponentTypography>
        <UiComponentTypography class-name="mt-4">
            نرس‌لند تمام تلاش خود را می‌کند تا محصولات سالم و با کیفیت به دست مشتری برسند. با این حال، در صورت وجود
            هرگونه نقص یا آسیب در محصول، مشتری موظف است ظرف 24 ساعت پس از دریافت محصول، موضوع را به واحد پشتیبانی اطلاع
            دهد. نرس‌لند هیچ گونه مسئولیتی در قبال تاخیرهای ناشی از مشکلات پستی یا خدمات باربری ندارد.
        </UiComponentTypography>
        <UiComponentTypography class-name="mt-6" tag="h2" variant="h3">7. شرایط تغییر قوانین</UiComponentTypography>

        <UiComponentTypography class-name="mt-4">
            نرس‌لند حق دارد در هر زمان قوانین و مقررات خود را به‌روزرسانی کند. تغییرات از لحظه انتشار در وب‌سایت اعمال
            می‌شوند و مشتریان موظف به رعایت آنها هستند.
        </UiComponentTypography>
    </UContainer>
</template>

<script lang="ts" setup>
useSeoMeta({
    title: "قوانین و مقررات | فروشگاه رستری قهوه نرس‌لند",
    description: "قوانین و مقررات، شرایط ثبت سفارش، روش‌های پرداخت، نحوه ارسال و شرایط بازگشت کالا در فروشگاه آنلاین نرس‌لند.",
    canonical: "https://northland-co.com/terms-and-conditions",
    ogTitle: "قوانین و مقررات فروشگاه اینترنتی نرس‌لند",
    ogDescription: "شرایط و ضوابط خرید، ارسال و پشتیبانی در فروشگاه نرس‌لند.",
    robots: "index, follow",
});
</script>

<style></style>
